import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AppInsightsProvider } from 'Features/Error/AppInsightsProvider'
import { AppThemeProvider } from 'Features/App/AppThemeProvider'
import { Toaster } from 'Common/Supplyvue-ui'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from '../../'

// Module scope, not the render body: a QueryClient built per render throws the
// whole query cache away every time AppProviders re-renders.
//
// Defaults: data is fresh for a minute and not refetched on window focus. The
// library defaults (stale at once, refetch on focus) made every page mount and
// every return to the tab re-download whole tables. Anything that changes the
// data invalidates its queries, so a save still shows straight away. Queries
// that must be live override this (template and safety-stock status poll while
// a run is in progress).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
})

export const AppProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <AppThemeProvider>
          <Toaster />
          <AppInsightsProvider>{children}</AppInsightsProvider>
          <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        </AppThemeProvider>
      </QueryClientProvider>
    </MsalProvider>
  )
}
